import errorMessagesEn from 'plugins/i18n/errorMessages.en.ts'

export default {
	toast: {
		question: {
			discardChanges: 'Do you really want to discard the changes?',
			deleteCis: 'Do you really want to delete this C.I.S.?',
			deleteLinkedDocuments: 'Should the linked documents also be deleted?',
			saveItem: 'Do you really want to save {name}?',
			deleteNoteType: 'Do you really want to delete the note type {name}?',
			deleteCategory: 'Do you really want to delete this category?',
			deleteImage: 'Do you really want to delete this image?',
			deleteSubcategory: 'Do you really want to delete this subcategory?',
			approveOrRejectBookings: 'Do you really want to {status} all bookings?',
			discardUnsavedChanges:
				'Do you really want to discard the unsaved changes?',
			resetSettings: 'Do you really want to reset the settings?',
			existingAccountWarning:
				'An account already exists with the provided email address. The password and profile picture will not be applied if you continue! Do you want to use a different email address or continue?',
			deleteTeamMember:
				'Do you really want to delete the team member {member}?',
			deactivateTeamMember:
				'Do you want to deactivate the team member {member}? They can no longer be assigned and lose access. Existing assignments are kept.',
			activateTeamMember: 'Do you want to reactivate the team member {member}?',
			deleteTemplate: 'Do you really want to delete this template?',
			confirmCopyRoleSettings:
				'Do you want to apply the settings from the person role {hp_id} - {name}?',
			deleteDocument: 'Do you really want to delete this document?',
			deleteDocumentOrFile:
				'Do you want to delete the document with <b>{count} files</b> or the file <b class=\\"d-inline-block text-truncate\\" style=\\"max-width: 150px;line-height: 10px\\">{fileNotes}</b>?',
			deleteFaqCategory: 'Do you really want to delete this FAQ category?',
			deleteFaqEntry: 'Do you really want to delete this FAQ entry?',
			noteVisibilityWarnText:
				'This note will be visible to @.lower:{visibleUsers} users, and @.lower:{notifiedUsers} users will be notified because no property was selected. Do you want to continue?',
			deleteNote: 'Do you really want to delete this note?',
			deleteTask: 'Do you really want to delete this task?',
			sendCredentials:
				'Do you really want to send the access credentials? The existing password will be overwritten.',
			discardChanges: 'There are unsaved changes. Do you want to discard them?',
			deleteContainerOrUnlink:
				'Do you want to delete the container or remove the link?',
			deleteDocumentType: 'Do you really want to delete this document type?',
			deleteDocumentTypeWithDocs:
				'Do you really want to delete this document type? <span style="font-weight: bold; color: #fff">All documents with this type will also be deleted.</span>',
			deleteComment: 'Do you really want to delete the comment?',
			deleteRoom: 'Do you really want to remove the room {roomName}?',
			releaseProtocol:
				'Do you really want to proceed and release the protocol for signature?<br />Changes will no longer be possible afterward.',
			confirmDeletePersonalData:
				'Please confirm that your personal data should be deleted from the portal and your manager will be informed.',
			sendReminderToAll:
				'Do you really want to send a reminder to all selected people?',
		},
		success: {
			copied_singular: '@:{element} were copied',
			updated_singular: '@:{element} was updated',
			updated_plural: '@:{element} were updated',
			created_singular: '@:{element} was created',
			created_plural: '@:{element} were created',
			deleted_singular: '@:{element} was deleted',
			deleted_plural: '@:{element} were deleted',
			saved_singular: '@:{element} was saved!',
			edited_singular: '@:{element} was edited',
			sent_singular: '@:{element} was sent!',
			sent_plural: '@:{element} were sent',
			/**/
			emailTemplateUpdate: 'Your email templates were updated',
			emailSent: 'An email was sent to your address',
			passwordSaved: 'Your password was saved',
			passwordUpdated: 'Your password was updated',
			settingsCopied: 'Settings were copied',
			permissionsUpdated: 'Permissions were updated',
			linkedContractsUpdated: 'The linked contracts were successfully updated',
			remindersSent: '{length} reminders were sent',
			commentCreated: 'Comment was successfully created',
			commentAndEmailSent: 'Comment and email were successfully sent',
			meterReadingReleased: 'Meter reading was successfully released',
			meterReadingRejected: 'Meter reading was successfully rejected',
			meterReadingsUpdated: 'Meter reading was successfully updated',
			reportToInsurance:
				'The report was successfully submitted to the insurance',
			linksUpdated: 'Links were successfully updated',
			requestProcessed: 'The request has been processed',
			requestSent: 'The request has been sent',
			reportSubmitted: 'Your report was successfully submitted!',
			reviewersStored: 'Reviewers were stored',
			protocolCreationFailed: 'Error while creating the protocol',
			protocolCreated: 'The protocol was created',
			welcomeEmailSent: 'Welcome email was sent!',
			deletedSelection: '{value} {name}',
			welcomeEmailsSent: '{count} welcome email(s)',
			invitationsSent: '{count} invitations were sent',
			documentsUpdated: 'Your documents were successfully updated',
			settingsUpdated: 'Your settings were updated',
		},
		info: {
			maintenanceNotice: {
				title: 'Important notice',
				notifications:
					'Due to maintenance work, no notifications are being sent at the moment.',
			},
			noFilesInContainer: 'There are no files in the attached container.',
			sessionExpired:
				'Your session has expired. You have been logged out automatically.',
			introDismissed:
				'No further introduction information will be shown to you.<br />You can restart the tour anytime under "Profile → Settings".',
			tasksEdit: 'Already transferred tasks can only be edited in HausPerfekt!',
			noDataRedirected:
				'No data available. You have been redirected automatically.',
			actingAsUser:
				'You are now acting as <b>{email}</b>!<br /> You can return to your own account at any time via the profile icon in the top right.',
			actingAsSelf: 'You are now acting as yourself.',
			confirmResetMessage:
				'Confirming this action will reset certain inputs to maintain data relationship integrity. {value}',
		},
		error: {
			applicationUnavailable:
				'The application is temporarily unavailable. Please try again later.',
			applicationInMaintenance:
				'The application is under maintenance. Please try again later.',
			applicationInvalidSubdomain:
				'The address you entered is invalid. Please check the subdomain and reload the page afterwards.',
			address_creation_failed: 'Address creation failed',
			passwordSaveFailed:
				'<b>Your password could not be saved.</b><br />Either the correct email address was not provided or the password request is no longer valid.<br />Please try again!',
			element: 'The Element',
			elementNotDeleted:
				'@:{entity} could not be deleted because it is still used by other data!',
			incorrectCurrentPassword: 'The current password is incorrect',
			placeholderNotCopied:
				'Unfortunately, the placeholder could not be copied!',
			invalidData: 'Invalid data! Please copy the desired data again.',
			dataSaveFailed: 'Error saving data',
			dataLoadFailed: 'Error loading data',
			protocolLoadIncomplete:
				'Not all data could be loaded. The protocol may be incomplete — please close the dialog and try again.',
			noDocumentTypeDefined:
				"No document type has been defined for the <b>protocol</b> yet. Please click <a href='/administration/settings/generic'>here</a> to make the necessary change.",
			noteCreationFailed:
				'Something went wrong while creating the note, please try again',
			noPermission: 'No permission',
			noPermissionDetails:
				'Your login credentials are correct, but no additional data is linked to your account. Please contact your administrator.',
			defaultLoginError:
				'An error occurred during login, please try again later.',
			loginFailed: 'Login failed',
			errorMessages: errorMessagesEn,
			teamMemberNotCreated:
				'The team member could not be created because a team member with the same email address already exists.',
			meterReadingNotAccepted: 'The meter reading was not accepted!',
			meterReadingNotSaved:
				'The meter reading could not be saved because a meter reading has already been submitted that is pending approval and has a higher value {value}.',
			subjectRequired: 'Subject is a required field',
			recipientRequired: 'Please select a recipient',
			notAllItemsDeleted: 'Not all @:{name} could be deleted',
			notificationNotSent:
				'A notification for the note: <b>{subject}</b> could not be sent',
			noteUpdateFailed:
				'Something went wrong while updating the note, please try again',
			fileNotFound: 'The file is unfortunately not available!',
			reportInsuranceFailed: 'Error loading the insurance report',
			genericError: 'An error has occurred',
			userAccountsLoadFailed: 'Error loading user accounts',
			sendingWelcomeEmailsFailed: 'Error sending welcome emails',
			addAtLeastOneFile: 'Please add at least one file.',
			genericRetryError: 'An error has occurred. Please try again.',
			maxFilesExceeded: 'You can select up to {maxFiles} file(s)',
			filesExceedMaxSize: 'Some files exceed the maximum size of {maxSize} MB',
			unsupportedFileType: 'Unsupported file type: {files}',
			fileDownloadFailed: 'Error downloading the file!',
			tooManyAttempts:
				'You have made too many attempts to log in. Please try again in a few minutes.',
			invalidAccessAtAddress:
				'There is no valid access at the specified address.<br />Please check the spelling or contact your property management.',
		},
	},
}
